import { render, staticRenderFns } from "./NavButton.vue?vue&type=template&id=075866a8&scoped=true&"
import script from "./NavButton.vue?vue&type=script&lang=js&"
export * from "./NavButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075866a8",
  null
  
)

export default component.exports